import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "to" ]

  copy(e) {
    e.preventDefault()
    this.toTarget.value = this.data.get('value')
    this.toTarget.animate({ backgroundColor: ['#FBFB84', '#fff'] }, 500)
  }

}
